import colors from '@/theme/constants/colors';
import typography from '@/theme/typography';
import styled, {css, keyframes} from 'styled-components';

const circleAnimation = keyframes`
0%{
transform: rotate(0deg);
}
100%{
transform: rotate(360deg);
}
`;

const centered = css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`;

export const StyledLoading = styled.div`
  width: 100%;
  height: 400px;
  background: ${colors.white};
  position: relative;

  &::before {
    content: '';
    display: block;
    height: 60px;
    width: 100px;
    background: ${colors.white};
    border-radius: 50%;
    border: 2px solid ${colors.red75};
    ${centered}
  }

  &::after {
    content: '';
    display: block;
    height: 50px;
    width: 200px;
    background: ${colors.white};
    ${centered}
    animation: 2s ${circleAnimation} linear infinite;
  }

  p {
    width: fit-content;
    height: fit-content;
    z-index: 10;
    color: ${colors.darkBlue100};
    ${typography.Subtitle3}
    ${centered}
  }
`;
